import difference from 'lodash/difference';
import filter from 'lodash/filter';
import orderBy from 'lodash/orderBy';
import uniqBy from 'lodash/uniqBy';
import {capitalize, sanitize} from '../shared/helper/utilitarioString';
import {getServiceName} from '../shared/helper/serviceLauncher';
import stemmer from 'snowball-stemmer.jsx/dest/portuguese-stemmer.common'
import store from "../store";
import {encodeUrlNb} from "../shared/helper/formatadores";
import deburr from "lodash/deburr";
import stopwords from "../shared/helper/stopwords";
import itensFixos from "../painel/component/drawer/menu.json";

export const getMenuObject = function(menuItems, key, value) {
    if(menuItems == null){
        return null;
    }
    let itemEncontrado;
    menuItems.some(function iter(itemMenu) {
        if (itemMenu[key] === value) {
            itemEncontrado = itemMenu;
            return true;
        }
        return Array.isArray(itemMenu.items) && itemMenu.items.some(iter);
    });
    return itemEncontrado;
};

export const flattenMenu = function(items) {
    const flattened = [];
    function iter(o) {
        o.title = getServiceName(o) || '';
        o.items = o.items || o.subItens || [];
        flattened.push(o);
        if (Array.isArray(o.items)) {
            o.items.forEach(iter);
        }
    }
    items.forEach(iter);
    return flattened;
}


const portugueseStemmer = new stemmer.PortugueseStemmer();

export const filterMenuObjects = function(termoBusca) {

    const ServicosIndevidos = Object.freeze({
        EXIGENCIA_EXPRESSA: "EXIGEXPRES",
        CUMPRIMENTO_EXIGENCIA: "CEXIG",
        CANCELAR_CERTIDAO_TEMPO_CONTRIBUICAO: "TCANCTC",
        REVISAO_CERTIDAO_TEMPO_CONTRIBUICAO: "TREVCTC",
        SIMULACAO_TEMPO_CONTRIBUICAO_RENDA_INICIAL: "SCTC",
        CONSULTAR_DESCONTOS_PENSIONISTA: "EACONSDESP",
        CONSULTAR_DESCONTOS_HERDEIRO: "EACONSDESH",
        CONSULTAR_DESCONTOS_TITULAR: "EACONSDESC"
    })

    const inputValue   = deburr(termoBusca.trim()).toLowerCase();
    const semStopWords = difference(inputValue.split(" "), stopwords).join(" ");
    const inputLength  = semStopWords.length;

    if (inputLength === 0)
        return [];
    else {
        const menuItems = store.getState().app.menuItems;
        let beneficios = [];
        if (store.getState().session.beneficios && store.getState().session.beneficios.length > 0) {
            beneficios = store.getState().session.beneficios.map(e =>
                ({
                    nbLink: 'Consultar Benefício ' + e.numero,
                    description: capitalize(e.especie),
                    nb: encodeUrlNb(e.numero),
                    weight: 3,
                    tags: ['consultar', 'meus', 'beneficio', 'nb', 'auxilio','recurso','procuracao', 'carta', 'concessao', 'conssessao', 'concecao']
                }));
        }

        const searchableItens = [...menuItems].concat(beneficios, itensFixos);

        let listaBusca = sanitize(semStopWords).split(' ');
        let filtrados = filter(flattenMenu(searchableItens), (o) => {
            let termosItem = sanitize(o.title).split(' ');
            
            if (o.tags) {
                termosItem = termosItem.concat(o.tags.map(t => sanitize(t)));
            }
            
            if (o.title) {
                termosItem = termosItem.concat(sanitize(o.title).split(' '))
            }

            if (o.description) {
                termosItem = termosItem.concat(sanitize(o.description).split(' '))
            }

            return listaBusca.every(tb => termosItem.some(ti => {
                if (o.sigla !== ServicosIndevidos.EXIGENCIA_EXPRESSA &&
                    o.sigla !== ServicosIndevidos.CANCELAR_CERTIDAO_TEMPO_CONTRIBUICAO &&
                    o.sigla !== ServicosIndevidos.CUMPRIMENTO_EXIGENCIA && 
                    o.sigla !== ServicosIndevidos.REVISAO_CERTIDAO_TEMPO_CONTRIBUICAO &&
                    o.sigla !== ServicosIndevidos.SIMULACAO_TEMPO_CONTRIBUICAO_RENDA_INICIAL &&
                    o.sigla !== ServicosIndevidos.CONSULTAR_DESCONTOS_PENSIONISTA &&
                    o.sigla !== ServicosIndevidos.CONSULTAR_DESCONTOS_HERDEIRO &&
                    o.sigla !== ServicosIndevidos.CONSULTAR_DESCONTOS_TITULAR
                ) {
                    return ti.includes(portugueseStemmer.stemWord(tb));
                }                 
            }));
        });

        return orderBy(uniqBy(filtrados, e => e.title), e => e.title ? e.title : 0);   
    }
};

export function lockBackground() {
    let body = document.querySelectorAll("body");
    body[0].style.setProperty('overflow', 'hidden', 'important');
    body[0].style.setProperty('position', 'fixed', 'important');
}

export function releaseBackground() {
    if (store.getState().app.searchText.length < 3) {
        let body = document.querySelectorAll("body");
        body[0].style.setProperty('overflow', 'auto', 'important');
        body[0].style.setProperty('position', 'static', 'important');
    }
}

export function compararDatas(dataStr1, dataStr2, sort = 'ASC') {
    const data1 = new Date(dataStr1);
    const data2 = new Date(dataStr2);

    if (isNaN(data1.getTime()) && isNaN(data2.getTime())) {
        return 0;
    }
    if (!isNaN(data1.getTime()) && isNaN(data2.getTime())) {
        return 1;
    }
    if (!isNaN(data2.getTime()) && isNaN(data1.getTime())) {
        return -1;
    }

    return sort === 'DESC' ? data2 - data1 : data1 - data2;
}